import React from 'react';
import ServiceCard from './ServiceCard';
import {
    LineChart,
    Cpu,
    Binary,
  } from 'lucide-react';
  
interface ServicesSectionProps {
  scrollToRef: (ref: React.RefObject<HTMLDivElement>) => void;
  refs: {
    hftRef: React.RefObject<HTMLDivElement>;
    mlRef: React.RefObject<HTMLDivElement>;
    caRef: React.RefObject<HTMLDivElement>;
  };
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ scrollToRef, refs }) => {
  return (
    <section className=" py-12 md:py-24 lg:py-32 ">
      <div className="container px-4 md:px-6">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3 justify-center">
          <ServiceCard
            icon={<LineChart className="h-12 w-12 text-primary" />}
            title="High-Frequency Trading"
            description="Lightning-fast execution with sophisticated market-making strategies"
            onLearnMore={() => scrollToRef(refs.hftRef)}
          />
          <ServiceCard
            icon={<Cpu className="h-12 w-12 text-primary" />}
            title="Machine Learning Models"
            description="Advanced AI algorithms that adapt to market conditions in real-time"
            onLearnMore={() => scrollToRef(refs.mlRef)}
          />
          <ServiceCard
            icon={<Binary className="h-12 w-12 text-primary" />}
            title="Custom Algorithms"
            description="Tailored trading strategies designed for your specific requirements"
            onLearnMore={() => scrollToRef(refs.caRef)}
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;